export default {
      id: "locker-usage",
      viewBox: "0 0 10 13",
      url: "assets/" + "sprite.svg#locker-usage",
      toString: function () {
        return this.url;
      }
    }